import { LitElement, html, css } from '@hh/global.js'

class HHAnnouncement extends LitElement {
  static get properties() {
    return {
      delay: { type: Number },
      crossfade: {
        type: Boolean,
        reflect: true,
      },
    }
  }

  constructor() {
    super()
    this.interval = null
    this.currentIndex = 0
  }

  firstUpdated() {
    const slot = this.shadowRoot.querySelector('slot')
    slot.addEventListener('slotchange', () => {
      this.container = this.querySelector('.hh-css-slider')
      this.announcements = this.container.querySelectorAll('.announcement-bar')
      this.updateHeight()
      this.initSlider()
    })
    this.addKeyboardNavigation()
  }

  initSlider() {
    this.startSlider()
    this.addEventListener('mouseenter', () => this.stopSlider())
    this.addEventListener('mouseleave', () => this.startSlider())
    this.addFocusAndBlurListeners()
  }

  addFocusAndBlurListeners() {
    this.announcements.forEach((announcement, index) => {
      announcement.addEventListener(
        'focus',
        (event) => {
          if (
            event.sourceCapabilities &&
            event.sourceCapabilities.firesTouchEvents
          ) {
            return
          }
          this.stopSlider()

          this.removeFocusToAnnouncement()
          announcement.classList.add('keyboard-focus')
        },
        true
      )

      announcement.addEventListener(
        'blur',
        (event) => {
          const newFocusedElement = event.relatedTarget
          if (
            newFocusedElement &&
            newFocusedElement.classList.contains('announcement-bar')
          ) {
            this.currentIndex = Array.from(this.announcements).findIndex(
              (el) => el === newFocusedElement
            )
          }
          this.restartTimer()
          announcement.classList.remove('keyboard-focus')
        },
        true
      )
    })
  }

  addKeyboardNavigation() {
    document.addEventListener('keydown', (event) => {
      const { target } = event
      if (!this.contains(target)) return

      if (event.code === 'ArrowLeft') {
        this.stopSlider()
        this.prevAnnouncement()
        this.focusIndexAnnouncement()
        this.restartTimer()
      } else if (event.code === 'ArrowRight') {
        this.stopSlider()
        this.nextAnnouncement()
        this.focusIndexAnnouncement()
        this.restartTimer()
      }
    })
  }

  prevAnnouncement() {
    this.currentIndex--
    if (this.currentIndex < 0) {
      this.currentIndex = this.announcements.length - 1
    }
    this.updateAnnouncements()
  }

  nextAnnouncement() {
    this.currentIndex++
    if (this.currentIndex >= this.announcements.length) {
      this.currentIndex = 0
    }
    this.updateAnnouncements()
  }

  focusIndexAnnouncement() {
    setTimeout(() => {
      this.announcements[this.currentIndex].focus()
    }, 300)
  }

  removeFocusToAnnouncement() {
    this.announcements.forEach((announcement) => {
      announcement.classList.remove('keyboard-focus')
    })
  }

  startSlider() {
    this.interval = setInterval(() => {
      this.nextAnnouncement()
    }, this.delay)
  }

  stopSlider() {
    clearInterval(this.interval)
  }

  restartTimer() {
    this.stopSlider()
    this.startSlider()
  }

  updateAnnouncements() {
    if (this.crossfade) {
      this.updateHeight()
      this.announcements.forEach((announcement, index) => {
        announcement.style.opacity = '0'
        announcement.style.pointerEvents = 'none'

        if (index === this.currentIndex) {
          announcement.style.opacity = '1'
          announcement.style.pointerEvents = 'auto'
        }
      })
    } else {
      const targetScrollPosition =
        this.currentIndex * this.container.clientWidth
      this.animateScroll(targetScrollPosition)
    }
  }

  animateScroll(targetScrollPosition) {
    this.container.scrollTo({
      left: targetScrollPosition,
      behavior: 'smooth',
    })
  }

  updateHeight() {
    const currentAnnouncement = this.announcements[this.currentIndex]
    this.style.height = `${currentAnnouncement.offsetHeight}px`
    this.style.display = 'block'
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-announcement', HHAnnouncement)
